var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-2",attrs:{"depressed":"","disabled":!_vm.activationStore.isActivated,"color":"primary"},on:{"click":_vm.create}},[_vm._v(" Create "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v(" mdi-plus-thick ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }